<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-1">
                  <base-button type="primary" size="sm" @click="$router.back()"
                    ><i class="ni ni-bold-left"></i
                  ></base-button>
                </div>
                <div class="col-8">
                  <h3 class="mb-0">
                    {{ $t("edit_products") }}
                  </h3>
                </div>
              </div>
            </div>
            <template>
             <createOrUpdate :data="product" />
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createOrUpdate from './form/createOrUpdate.vue'
import {mapActions} from 'vuex'
export default {
  name: "create-company",
  components: {
   createOrUpdate
  },
    async created() {
      this.product = (await this.getProduct(this.$route.params.id)).data;
    },
  data(){
    return{
      product:{}
    }
  },
  methods: {
    ...mapActions({
      getProduct: "product/getProduct",
    })
  },
}
</script>

<style>
</style>